import TailwindThemeProvider from "../TailwindThemeProvider";

const LightThemeProvider: FC = ({ children }) => (
  <TailwindThemeProvider colorScheme="light">{children}</TailwindThemeProvider>
);

export default LightThemeProvider;
